import { VALUES } from "@/data/site";

export default function Marquee() {
  const row = [...VALUES, ...VALUES, ...VALUES];
  return (
    <div className="overflow-hidden border-y border-forest-border bg-forest-surface py-10" data-testid="values-marquee">
      <div className="flex w-max animate-marquee items-center gap-24 md:gap-32">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-24 md:gap-32">
            <span className="whitespace-nowrap font-serif text-3xl font-light tracking-wide text-gold/90 md:text-5xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
